import { PortalSelectedLoan } from '../../App';

export const getTotalAmountDue = (loan: PortalSelectedLoan, ignoreWorkoutPlans: boolean = false): number => {
  const {
    currentSnapshot: {
      totalAmountRemainingFromBorrower,
      totalWorkoutPlanAmountRemainingFromBorrower,
      activeWorkoutPlan,
      maturityConfig: { isMaturing },
      expectedPayoffTotal,
      isFullInterestOnlyLoan,
    },
  } = loan;

  if (isMaturing && !isFullInterestOnlyLoan && totalAmountRemainingFromBorrower === 0) {
    return expectedPayoffTotal;
  }

  if (
    !ignoreWorkoutPlans &&
    activeWorkoutPlan &&
    ['ForbearanceWorkoutPlan', 'FlexModificationWorkoutPlan'].includes(activeWorkoutPlan.__typename ?? '')
  ) {
    return totalWorkoutPlanAmountRemainingFromBorrower ?? 0;
  }

  return totalAmountRemainingFromBorrower;
};
